import { getHttpClient } from "@/core/api";

export async function getOrganization() {
  const response = await getHttpClient().get("v2/organization");
  return response.data;
}
